export const APPNAME = "TruVideo"
export const API_URL = process.env.REACT_APP_API_URL

//slice name and api end point
export const AUTH = "auth"
export const DASHBOARD = '/dashboard'
export const PROFILE = "/profile"
export const MODALS = "modals"
export const SETTINGS = "settings"
export const ADMINDASHBOARD = "/admin-dashboard"
export const CALLDASHBOARD = "/call-dashboard"
export const CHANGEPASSWORD = "change-password";
export const CHANGE_PASSWORD = "changepassword/:uuid";
export const CALL = '/call'
export const ALL = 'all'
export const GETCALLDETAILBYID = 'getCallDetails'
export const GETCONVERSATIONDETAILBYID = 'getConversationDetails'
export const DOWNLOADCSV = 'download-csv'
export const RESTARTAGENT = "restart-agent"
export const DOWNLOADTRANSCRIPT = "getBotTranscript"
export const UPDATEREASONSTATUS = "update-reason-status"
export const REBOOK = "book-appointment"
export const COMMENT = "update-comment"
export const GETBOOKINGDATA = "get-booking-data"
export const UPDATEBOOKINGDATA = "update-booking-data"
export const DASBOARDSUMMARY = "dashboard-summary"

//common redux statuses 
export const IDLE = 'idle'
export const LOADING = 'loading'
export const SUCCEEDED = 'succeeded'
export const FAILED = 'failed'

// reducers response //
export const PENDING = "pending";
export const FULFILLED = "fulfilled";
export const REJECTED = "rejected";

//router paths and asyncThunk actions
export const SIGNUP = "/signup";
export const SIGNIN = "/signin";
export const DEMO = "/demo";
export const FORGOTPASSWORD = "/forgot-password";
export const RESETPASSWORD = "/reset-password";




//translation types
export const EN = 'en'